// Services
import ComponentService from 'services/component.service';

// Components
import CoolantSampleGrid from './coolant-sample/CoolantSampleGrid.vue';
import CoolantSampleDetail from './coolant-sample/SampleDetail/CoolantSampleDetail.vue';
import CoolantSampleReport from './coolant-sample/report/CoolantSampleReport.vue';
import CompanyGrid from './company/CompanyGrid.vue';
import CommentGrid from './comment/CommentGrid.vue';
import UnitTypeGrid from './unit-type/UnitTypeGrid.vue';
import ManufacturerModelGrid from './manufacturer-model/ManufacturerModelGrid.vue';
import FluidGrid from './fluid/FluidGrid.vue';
import FluidManufacturerGrid from './fluid-manufacturer/FluidManufacturerGrid.vue';
import FluidBrandGrid from './fluid-brand/FluidBrandGrid.vue';
import FluidWeightGrid from './fluid-weight/FluidWeightGrid.vue';
import CustomerGrid from './customer/CustomerGrid.vue';
import OilSampleGrid from './oil-sample/OilSampleGrid.vue';
import OilSampleDetail from './oil-sample/SampleDetail/OilSampleDetail.vue';
import OilSampleGraph from './oil-sample/graph/OilSampleGraph.vue';
import OilSampleReport from './oil-sample/report/OilSampleReport.vue';
import UnitGrid from './unit/UnitGrid.vue';
import UserGrid from './user/UserGrid.vue';
import BillingReport from './billing-report/BillingReport.vue';
import GroupFileUpload from './group-file-upload/GroupFileUpload.vue';
import Dashboard from './dashboard/Dashboard.vue';
import CoolantSampleGraph from './coolant-sample/graph/CoolantSampleGraph.vue';

/*
  All component elements should be the kebab-cased version of the component name.
  ex. ExampleComponent => example-component
*/

const imports = [
  {
    component: CoolantSampleGrid,
    element: 'coolant-sample-grid'
  },
  {
    component: CoolantSampleDetail,
    element: 'coolant-sample-detail'
  },
  {
    component: CoolantSampleReport,
    element: 'coolant-sample-report'
  },
  {
    component: CoolantSampleGraph,
    element: 'coolant-sample-graph'
  },
  {
    component: CompanyGrid,
    element: 'company-grid'
  },
  {
    component: CommentGrid,
    element: 'comment-grid'
  },
  {
    component: UnitTypeGrid,
    element: 'unit-type-grid'
  },
  {
    component: ManufacturerModelGrid,
    element: 'manufacturer-model-grid'
  },
  {
    component: FluidGrid,
    element: 'fluid-grid'
  },
  {
    component: FluidManufacturerGrid,
    element: 'fluid-manufacturer-grid'
  },
  {
    component: FluidBrandGrid,
    element: 'fluid-brand-grid'
  },
  {
    component: FluidWeightGrid,
    element: 'fluid-weight-grid'
  },
  {
    component: CustomerGrid,
    element: 'customer-grid'
  },
  {
    component: OilSampleDetail,
    element: 'oil-sample-detail'
  },
  {
    component: OilSampleGraph,
    element: 'oil-sample-graph'
  },
  {
    component: OilSampleGrid,
    element: 'oil-sample-grid'
  },
  {
    component: OilSampleReport,
    element: 'oil-sample-report'
  },
  {
    component: UnitGrid,
    element: 'unit-grid'
  },
  {
    component: UserGrid,
    element: 'user-grid'
  },
  {
    component: BillingReport,
    element: 'billing-report'
  },
  {
    component: GroupFileUpload,
    element: 'group-file-upload'
  },
  {
    component: Dashboard,
    element: 'dashboard'
  }
];

export default {
  loadComponents() {
    ComponentService.mountComponents(imports);
  }
};
